

import React, { memo, useRef, useState, useEffect } from 'react';
import { FormModal, Text, Input, Button } from '../../../../ui-kit';

import Uploader from '../../../Splash/common/components/Uploader';

import './styles/_manage-social-settings.scss';

const DEFAULT_THUMBNAIL = 'https://d3on5ehsnqzzp4.cloudfront.net/Splash/Elevate/default-preview-image.png';





















const ManageSocialSettings = (props) => {
  const {
    visible,
    onClose,
    addFilesToQueue,
    organisationId,
    updateAsset,
    assetsMap,
    updateTemplate,
    templateId,
    templateDetails,
    getPublicAssetUrl,
    workspaceSocialSettings
  } = props;

  const { title = '', description = '', thumbnailUrl = '' } = templateDetails || {};

  const [seedTitle, setSeedTitle] = useState(title || workspaceSocialSettings.title);
  const [seedDescription, setSeedDescription] = useState(
    description || workspaceSocialSettings.description
  );
  const [uploadedAssetId, setUploadedAssetId] = useState(undefined);
  const [seedThumbnailUrl, setSeedThumbnailUrl] = useState(
    thumbnailUrl || workspaceSocialSettings.thumbnail
  );

  const uploaderRef = useRef();

  useEffect(() => {
    if (uploadedAssetId) {
      const asset = assetsMap.get(uploadedAssetId);
      if (asset && asset.loadedPercent === 100 && asset.uploadStatus !== 'active') {
        (async () => {
          const { data, error } = await getPublicAssetUrl(asset.assetId);
          if (!data || error) {return;}
          const { getPublicAssetUrl: getPublicAssetUrlData } = data;
          setSeedThumbnailUrl(getPublicAssetUrlData);
        })();
      }
    }
  }, [uploadedAssetId, assetsMap]);

  const filePickerRefCallBack = (ref) => {
    uploaderRef.current = ref;
  };

  const onBrowse = () => {
    if (uploaderRef.current) {
      uploaderRef.current.openFileChooser();
    }
  };

  const onChange = ({ assetId: newAssetId }) => {
    if (newAssetId) {
      setUploadedAssetId(newAssetId);
    }
  };

  const onTitleChange = (e) => {
    setSeedTitle(e.target.value);
  };

  const onDescriptionChange = (e) => {
    setSeedDescription(e.target.value);
  };

  const onSave = async () => {
    await updateTemplate({
      templateId,
      action: 'UPDATE',
      optionalParams: {
        title: seedTitle,
        description: seedDescription,
        thumbnailUrl: seedThumbnailUrl
      }
    });

    onClose();
  };

  return (
    <FormModal
      key="manage-social-settings-modal"
      title="Manage Display Settings"
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      subtitle="Customise how your message appears to your recipient when sharing on popular messaging apps."
      saveDisabled={!seedTitle}
      stayOpenOnSave
      saveText="Save Changes">

      <>
        <div className="manage-social-settings-modal__thumbnail__edit">
          <Text heading5>Thumbnail</Text>
          <div className="manage-social-settings-modal__thumbnail__edit__section">
            <img
              style={{ width: '20%' }}
              alt="splash-thumbnail"
              loading="lazy"
              src={seedThumbnailUrl || DEFAULT_THUMBNAIL} />

            <div>
              <Text button>Upload a custom thumbnail to be used for this splash page</Text>
              <Text placeholder>Recommended: 1200x627 px  |  Up to 5MB</Text>
            </div>
            <div>
              <Button type="TERTIARY" onClick={onBrowse}>Browse File</Button>
            </div>
          </div>
        </div>
        <div className="manage-social-settings-modal__basic-info__edit">
          <Text heading5>Basic Info</Text>
          <div className="manage-social-settings-modal__basic-info__edit__section">
            <div className="manage-social-settings-modal__basic-info__edit__section__title">
              <Input
                id="splash-title"
                placeholder="Shootsta Elevate"
                label="Title"
                labelProps={{ required: true }}
                defaultValue={seedTitle}
                value={seedTitle}
                onChange={onTitleChange} />

              <Text label>Recommended up to 50 chars</Text>
            </div>
            <div className="manage-social-settings-modal__basic-info__edit__section__description">
              <Input
                id="splash-description"
                placeholder="Your personalised Elevate is ready!"
                label="Description"
                defaultValue={seedDescription}
                value={seedDescription}
                onChange={onDescriptionChange} />

              <Text label>Recommended up to 100 chars</Text>
            </div>
          </div>
        </div>
      </>
      <Uploader
        addFilesToQueue={addFilesToQueue}
        organisationId={organisationId}
        onChange={onChange}
        filePickerRefCallBack={filePickerRefCallBack}
        accepts={['image/*']}
        updateAsset={updateAsset} />

    </FormModal>);

};

export default memo(ManageSocialSettings);